import { useSelector } from 'react-redux';
import { Appstore } from '../redux';
import { useLocation } from 'react-router-dom';

const usePageState = () => {
  const { pathname } = useLocation();
  const pageState = useSelector((state: Appstore) => state.pageState[pathname]);

  const loadPageState = (setSort: any, setFilter: any, setPagination: any) => {
    if (pageState) {
      if (pageState.sort) {
        setSort(pageState.sort);
      }
      if (pageState.filter) {
        setFilter(pageState.filter);
      }
      if (pageState.pagination) {
        setPagination(pageState?.pagination);
      }
    }
  };

  const scrollPosition = (): number => {
    return pageState?.scrollPosition ?? 0;
  }

  return { loadPageState, scrollPosition };
};

export default usePageState;
